import React from 'react';
import saveAs from 'file-saver';
import Page from 'src/components/Page/Page';
import TertiaryButton from 'src/components/TertiaryButton/TertiaryButton';
import { useSivaContractDataExtract } from 'src/features/siva/ideas-and-companies/hooks/use-siva-contract-data-extract';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'src/components/DocumentTitle/DocumentTitle';
import useDocumentTitle from 'src/hooks/use-document-title';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';

const ExtractKtu = () => {
  const { downloadKtuData } = useSivaContractDataExtract();
  const { t: tSiva } = useTranslation('siva');
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { documentTitle } = useDocumentTitle(tPageTitles('sivaReporting'));

  return (
    <DocumentTitle title={documentTitle}>
      {downloadKtuData.isLoading ? (
        <LoadingPage />
      ) : (
        <Page>
          <div className="stack-large">
            <h1>KTU</h1>
            <TertiaryButton
              onClick={async () => {
                const file = await downloadKtuData.mutateAsync(true);
                saveAs(file.data, file.fileName);
              }}
              minimalPadding={true}
              icon={{ prefix: 'fal', iconName: 'file-export' }}
            >
              {tSiva('export.ktu.exportButton')}
            </TertiaryButton>
          </div>
        </Page>
      )}
    </DocumentTitle>
  );
};

export default ExtractKtu;
